import React, { useState, useEffect } from 'react';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import TableMyContract from './report/TableMyContract';
import { toast } from 'react-toastify';
import Modal from 'react-bootstrap/Modal';
import { ContractData } from '../../services/apifp';
import { ContentHeader } from '@components';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { logoutUser } from '@store/reducers/auth';

const Contract = () => {
  const user = useSelector((state: any) => state.auth.currentUser);
  const [data, setData] = useState<any[]>([]);
  const [page, setPage] = useState(0);
  const [key, setKey] = useState('history');
  const [filter, setFilter] = useState('');
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedContract, setSelectedContract] = useState<any>(null);
  const dispatch = useDispatch();

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setLoading(true);
      const contractData = await ContractData();

      if (!contractData || !Array.isArray(contractData)) {
        console.error("⚠️ API ส่งข้อมูลผิดพลาด:", contractData);
        dispatch(logoutUser());
        window.location.href = "/login";
        return;
      }

      console.log("✅ ข้อมูลที่ได้รับจาก API:", contractData);
      setData(contractData);
      setShowModal(false);
    } catch (error) {
      console.error("❌ โหลดข้อมูลล้มเหลว:", error);
      dispatch(logoutUser());
      window.location.href = "/login";
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedContract(null);
  };

  // 📌 เปิดเอกสาร PDF เมื่อกด View
  const handleViewContract = (contract) => {
    console.log("📄 เปิดเอกสาร:", contract);
    if (!contract?.PATHV2) {
      toast.error("❌ ไม่พบไฟล์เอกสาร!");
      return;
    }
    setSelectedContract(contract);
    setShowModal(true);
  };

  return (
    <div>
      <ContentHeader title="รายการสัญญา" />
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <Tabs id="controlled-tab-example" activeKey={key} onSelect={(k) => setKey(k)} className="mb-3">
                <Tab eventKey="history" title="ร่างสัญญา">
                  {loading ? (
                    <p>กำลังโหลดข้อมูล...</p>
                  ) : (
                    <TableMyContract 
                      items={data} 
                      page={page}
                      setFilter={setFilter}
                      filter={filter}
                      onPageChange={(newPage) => setPage(newPage)}
                      onViewContract={handleViewContract} // ✅ ส่งฟังก์ชันเปิดเอกสาร PDF
                    />
                  )}
                </Tab>
              </Tabs>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contract;
